import React, {Component} from "react";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {Card, Button, Row, Col} from "react-bootstrap";
import InlineForm from "../Elements/FromGroup/InlineForm";
import moment from "moment";
import RecordCustomerModal from "./RecordCustomerModal";
import RecordTagEditModal from "./RecordTagEditModal";
import { hasRecAceContract } from "../../components/AscUtils";


export default class RecordPlaybackModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // modal item
            show: false,
            modalType: null,
            customer_name: "",
            // メモ機能用のstate
            memoSaved: false,
            memoUpdated: false, // メモが更新されたかどうかのフラグ
            activeTranscriptIndex: null,
            tagUpdated: false, // タグ編集が行われたかどうか（モーダル閉じる時にテーブル再取得判定用）
            overviewExpanded: false, // 【#589】長い通話概要を全文表示しているか
            overviewOverflowing: false, // 【#589】折りたたみ表示で通話概要がはみ出しているか
        };
        this.audioRef = React.createRef();
        // Issue #406: 「保存済み」表示を消すためのタイマー。
        // state に持たせると setState の非同期性で clear 漏れが起きうるため
        // インスタンスフィールドで保持し、アンマウント時に確実にクリアする。
        this.memoSavedDisplayTimer = null;
        // Issue #445 ③: 保存の可否判定に使う値は描画に使わず、setState の非同期性で
        // 判定を誤らないよう memoSavedDisplayTimer と同じくインスタンスフィールドで保持する。
        this.memoSaveTimer = null;  // デバウンス待ちのタイマーID
        this.memoSaving = false;    // 保存中フラグ（競合状態防止）
        this.memoSavingValue = null; // 進行中の送信が運んでいるメモの内容
        // Issue #445 ①: 進行中の送信の完了後に送り直す内容（{ht60_id, memo}）
        this.queuedMemo = null;
        // Issue #406: アンマウント後にメッセージ表示を行わないための判定用
        this._isMounted = true;
    }

    getModalBranch = () => {
        switch (this.state.modalType) {
            case "addCustomer":
            case "editCustomer":
                return (
                    <RecordCustomerModal
                        show={this.state.show}
                        state = {this.state}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        validationHandle = {this.validationHandle}
                        onTextChange = {this.onTextChange}
                        onClickHandle = {this.onClickHandle}/>
                );
            case "tagEdit":
                return (
                    <RecordTagEditModal
                        show={this.state.show}
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        ht60_id={this.props.state.id}
                        categories={this.props.state.ht88_categories || []}
                        categoryMaster={this.props.categoryMaster || []}
                        ascAxios={this.props.ascAxios}
                        showErrorObjectMessage={this.props.showErrorObjectMessage}
                        onCategoriesChange={this.handleCategoriesChange}
                        options={this.props.options || {}}
                    />
                );
            default:
                return null;
            }
    }

    //CustomerModal用関数
    propSetState = state => {
        this.setState(state);
    }

    onTextChange = (event) => {
        let value = (event && event.target && event.target.value) ? event.target.value : "";
        this.setState({customer_name: value});
        this.props.propSetState({customer_name: value});
    }

    validationHandle = param => {
        let validation_flag = false;
        switch (param) {
            case "addCustomer":
            case "editCustomer":
                validation_flag = !!this.state.customer_name;
                break;
            default:
                break;
        }
        return validation_flag;
    }

    onClickHandle = async(param) => {
        let {modalType} = this.state;
        let {customer_name,dest_tel_number,customer_id} = this.props.state;
        if(param === 'deleteCustomer'){
            try{
                if (window.confirm(this.props.langText.Message.Record_CustomerDelete)) {
                    await this.props.ascAxios('post', `Record/customerDelete`, {
                        customer_id
                    });
                    this.props.propSetState({customer_name:"", customer_id:""});
                    alert(this.props.langText.Message.DataDeleteSuccess);
                }
            } catch (err) {
                console.error(err);
                this.props.showErrorObjectMessage({message: 'ModalTypeError'});
            } finally {
                this.setState({show: false});
            }
        } else if (param === "voiceDelete") {
            try {
                if (window.confirm(this.props.langText.Message.Record_VoiceDelete)) {
                    await this.props.ascAxios('post', `Record/voiceDelete`, {
                        id: this.props.state.id
                    });
                    await this.props.propSetState({show: false});
                    await this.props.reactTableRefresh();
                }
            } catch (err) {
                console.error(err);
                this.props.showErrorObjectMessage({message: 'ModalTypeError'});
            }
        } else if (param === "voiceRetry") {
            try {
                if (window.confirm(this.props.langText.Message.Record_VoiceRetry)) {
                    const ht60_id = this.props.state.id;
                    await this.props.ascAxios('post', `Record/exeAudio2TextByHt60Id`, {
                        id: ht60_id
                    });
                    alert(this.props.langText.Message.Record_VoiceRetryRequested);
                    await this.props.propSetState({show: false});
                    // 親側で対象行を処理中表示にし、完了までポーリングで自動更新する
                    this.props.onAudio2TextRetryStart(ht60_id);
                }
            } catch (err) {
                console.error(err);
                // 409 AlreadyProcessing 等のサーバエラーコードは showErrorObjectMessage が自動解決
                this.props.showErrorObjectMessage(err);
            }
        } else if (param === "callTextDownload") {
            try {
                this.props.downloadCallContents(this.props.state);
            } catch (err) {
                console.error(err);
                this.props.showErrorObjectMessage({message: 'ModalTypeError'});
            }
        } else if(modalType){
            try {
                switch (modalType) {
                    case 'addCustomer':
                        let add_data = await this.props.ascAxios('post', `Record/customerAdd`, {
                            customer_name,
                            dest_tel_number
                        });
                        this.props.propSetState({customer_id: add_data.data.insert_data.id});
                        alert(this.props.langText.Message.DataInsertSuccess);
                        break;
                    case 'editCustomer':
                        await this.props.ascAxios('post', `Record/customerEdit`, {
                            customer_id,
                            customer_name
                        });
                        alert(this.props.langText.Message.DataUpdateSuccess);
                        break;
                    default:
                        this.showErrorObjectMessage('ModalTypeError');
                        break;
                }
            } catch (err) {
                console.error(err);
                this.props.showErrorObjectMessage({message: 'ModalTypeError'});
            } finally {
                this.setState({show: false});
            }
        }
    }

    handleTranscriptClick = (startSeconds, index) => {
        const audioElement = this.audioRef.current;
        if (audioElement) {
            const targetTime = Number(startSeconds);
            if (!Number.isNaN(targetTime)) {
                audioElement.currentTime = Math.max(targetTime, 0);
                if (audioElement.paused) {
                    audioElement.play().catch(() => {});
                }
            }
        }
        this.setState({ activeTranscriptIndex: index });
    }

    viewVoiceMessage = (ht87_voice_log_to_text) => {
        try {
            let returnItems = [];
            switch (ht87_voice_log_to_text.status) {
                case "CONVERSION_COMPLETE":
                    if (ht87_voice_log_to_text.text_data_json) {
                        for (let i = 0; i < ht87_voice_log_to_text.text_data_json.length; i++) {
                            let position = "in" === ht87_voice_log_to_text.text_data_json[i].inout ? "left" : "right";
                            const startSecond = ht87_voice_log_to_text.text_data_json[i].start;
                            const isActive = this.state.activeTranscriptIndex === i;
                            returnItems.push(
                                <React.Fragment key = {i}>
                                    <div
                                        id={"message-box-"+i}
                                        className={`message-div ${position}${isActive ? " active" : ""}`}
                                        onClick={() => this.handleTranscriptClick(startSecond, i)}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter" || event.key === " ") {
                                                event.preventDefault();
                                                this.handleTranscriptClick(startSecond, i);
                                            }
                                        }}
                                    >
                                        <div className = {"message-box " + position}>
                                            <Row>
                                    <span className={"voice-time " +position}>
                                        {this.props.secToTime(Math.floor(ht87_voice_log_to_text.text_data_json[i].start))}
                                    </span>
                                            </Row>
                                            {ht87_voice_log_to_text.text_data_json[i].text}
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        }
                    } else {
                        returnItems.push(<div>
                            {this.props.langText.Body.audio2textNotFound}
                        </div>);
                    }
                    break;
                case "WORKING":
                case "REQUEST_ACCEPTED":
                    returnItems.push(<div>
                        {this.props.langText.Body.audio2textWorking}
                    </div>);
                    break;
                default:
                    returnItems.push(<div>
                        {this.props.langText.Body.audio2textFailed}
                    </div>);
                    break
            }

            return returnItems;
        } catch (e) {
            console.error(e);
            this.props.showErrorObjectMessage(e);
        }
    }

    /**
     * メモ・通話分類を編集できるか（Issue #549）
     *
     * サーバー側（/Record/updateMemo ほか）は permission_data.Record.update だけを見て
     * 403 を返す。会社設定 hm12_companies.options.sub_user_permission で
     * Record.update が false にされているサブユーザーは保存できないため、
     * 画面でも同じ値を見て編集させない。「入力できるのに保存だけ失敗する」状態を作らない。
     *
     * 見るのは props.recordPermission（呼び出し元が permission_data.Record を渡す）。
     * props.currentPermission は URL パス由来の**画面別**権限であり、このモーダルは
     * /Record（permission_data.Record）と /PhoneBook（permission_data.PhoneBook）の
     * 両方から開かれる。currentPermission を見ると電話帳経路でサーバーの判定と食い違い、
     * PhoneBook.update が false の利用者はメモを保存できるのに入力できなくなり、
     * 逆に Record.update だけ false の利用者は入力できるのに 403 になる。
     * recordPermission が渡らない場合は編集させない（fail-closed）。
     */
    canUpdateRecord = () => !!(this.props.recordPermission && this.props.recordPermission.update)

    /**
     * メモ変更ハンドラー（デバウンス処理付き）
     */
    onMemoChange = (event) => {
        // 読み取り専用のときは値が変わらないが、経路として塞いでおく
        if (!this.canUpdateRecord()) {
            return;
        }
        const newMemo = event.target.value;

        // 親のstateを更新（即座に反映）
        this.props.propSetState({ memo: newMemo });

        // 既存のタイマーをクリア
        if (this.memoSaveTimer) {
            clearTimeout(this.memoSaveTimer);
        }

        // 保存済み表示をリセット、メモ更新フラグをtrueに設定
        this.setState({
            memoSaved: false,
            memoUpdated: true // メモが更新されたことを記録
        });

        // 1.5秒後に保存
        this.memoSaveTimer = setTimeout(async () => {
            // Issue #406: 自然に発火した時点でタイマーを手放す。
            // 残したままだと memoSaveTimer が「デバウンス待ちがある」ことの
            // 信号として使えなくなる（発火済みの ID が truthy のまま残る）。
            this.memoSaveTimer = null;
            await this.saveMemo(newMemo);
        }, 1500);
    }

    /**
     * メモBlurハンドラー（即時保存）
     */
    onMemoBlur = async () => {
        // 【#549】更新権限が無いときは送信しない。blur は値を変えていなくても発火するため、
        // ここを塞がないと読み取り専用の利用者がモーダルを開くたびに 403 を踏む。
        if (!this.canUpdateRecord()) {
            return;
        }
        // 保存中の場合はスキップ（競合状態防止）。
        // ここで memoUpdated は true のまま残るが、進行中の送信が完了した時点で
        // flushPendingMemo が現在の内容と memoSavingValue を比較し、
        // 差分があればキュー経由で送り直すため、追記分は失われない。
        if (this.memoSaving) {
            return;
        }

        // 既存のタイマーをクリア
        if (this.memoSaveTimer) {
            clearTimeout(this.memoSaveTimer);
            this.memoSaveTimer = null;
        }

        // 現在のメモの値を即座に保存
        const currentMemo = this.props.state.memo || '';
        await this.saveMemo(currentMemo);
    }

    /**
     * メモをサーバへ送信する（Issue #406: 送信部分を共通化）
     *
     * 対象の録音IDを引数で受け取る。componentDidUpdate から呼ぶ場合、
     * 別の録音へ切り替わった時点では this.props が既に新しい録音を指しているため、
     * 呼び出し側が保存対象を明示する必要がある。
     *
     * @param {number} ht60_id - 保存対象の録音ID
     * @param {string} memo - 保存するメモ
     */
    postMemo = async (ht60_id, memo) => {
        await this.props.ascAxios('post', 'Record/updateMemo', {
            ht60_id: ht60_id,
            memo: memo
        });

        // 保存成功後、親コンポーネントのリストデータを更新
        // 一覧の同期に失敗しても保存自体は成功しているため、
        // 保存失敗（DataUpdateError）として扱わずログのみ残す
        try {
            if (this.props.updateListMemo) {
                this.props.updateListMemo(ht60_id, memo);
            }
        } catch (err) {
            console.error(err);
        }
    }

    /**
     * デバウンス待ちのメモが残っていれば即時保存する（Issue #406）
     *
     * デバウンス待ちの判定:
     * 　・memoUpdated が true　 … 未保存の編集がある
     * 　・memoSaveTimer がある … 発火前のタイマーが残っている
     * blur による即時保存（onMemoBlur）が先に走った場合は memoSaveTimer が null に
     * なるため、ここでは何もしない。
     *
     * Issue #445 ①: 保存中（memoSaving）の場合は早期 return せず、進行中の送信が
     * 運んでいる内容と現在の内容を比べる。進行中の送信は追記前の内容を運んでいるため、
     * その完了をもって保存済みとはみなせない。差があれば送信をキューイングし、
     * 進行中の送信の完了後（saveMemo の finally）に最新の内容を送り直す。
     *
     * @param {number} ht60_id - 保存対象の録音ID
     * @param {string} memo - 保存するメモ
     */
    flushPendingMemo = (ht60_id, memo) => {
        if (!this.state.memoUpdated) {
            return;
        }

        // Issue #445 ①: 送信の往復中は、進行中の送信の完了後に送り直す
        //
        // 往復中に複数回呼ばれた場合は queuedMemo を上書きする。これは意図した挙動で、
        // 送り直すべきなのは常に最後の編集内容だから。先に積んだ値を残すと、古い内容で
        // 上書きしてしまう。なお実際のライフサイクルでは componentDidUpdate が
        // memoUpdated を false にするため、2回目は冒頭の判定で早期 return する。
        if (this.memoSaving) {
            if ((memo || '') !== (this.memoSavingValue || '')) {
                this.queuedMemo = {ht60_id, memo: memo || ''};
            }
            return;
        }

        if (!this.memoSaveTimer) {
            return;
        }

        // 即時保存する分のデバウンスタイマーはここで手放す。呼び出し側にも
        // clearTimeout はあるが（デバウンス待ちでない場合のため）、二重送信の
        // 防止をこの関数の責務に含めておき、呼び出し箇所が増えたときの
        // 漏れを防ぐ。state のリセットは呼び出し側に任せる
        // （componentWillUnmount で setState したくないため）。
        clearTimeout(this.memoSaveTimer);
        this.memoSaveTimer = null;

        // componentDidUpdate / componentWillUnmount は同期のため await できない。
        // 送信の完了は待たず、失敗時のみログとメッセージで扱う。
        this.postMemo(ht60_id, memo || '')
            .catch(err => {
                console.error(err);
                // Issue #406: アンマウント済みでもメッセージは出す。
                // showErrorObjectMessage は親（Record / PhoneBook）のメソッドであり、
                // 子であるこのモーダルのマウント状態は親の生存とは無関係。
                // 特に PhoneBook.js は playbackModal: false で getPlaybackModal() が
                // null を返し即アンマウントするため、_isMounted で抑止すると
                // 「閉じる操作での保存失敗」が常に無通知になる。
                // 親ごと破棄される画面遷移では React の setState 警告が出るが、
                // 開発時のみの影響であり、保存失敗の黙殺よりは軽微と判断した。
                this.props.showErrorObjectMessage({message: 'DataUpdateError'});
            });
    }

    /**
     * メモ保存処理
     */
    saveMemo = async (memo) => {
        // Issue #445 ②: 送信を行わない経路で finally の memoSaving 解除が走らないよう、
        // 早期 return は try/finally の外で判定する。
        // メモが更新されていない場合はスキップ
        if (!this.state.memoUpdated) {
            return;
        }

        // 既に保存中の場合はスキップ（競合状態防止）
        if (this.memoSaving) {
            return;
        }

        // 保存中フラグを立てる。進行中の送信が運んでいる内容も控えておく
        // （Issue #445 ①: 往復中の追記を検出するため）
        this.memoSaving = true;
        this.memoSavingValue = memo || '';

        try {
            await this.postMemo(this.props.state.id, memo);

            // Issue #406: 送信中にアンマウントされた場合、以降の setState は
            // アンマウント後の更新になるため打ち切る（保存自体は完了している）
            if (!this._isMounted) {
                return;
            }

            // Issue #406: 送信の往復中に入力された分を「保存済み」と誤認しない。
            // memoUpdated は「未保存の編集がある」ことを表すフラグだが、何を送信したかとは
            // 紐づいていないため、成功時に無条件で false にすると次の順序で編集が失われる。
            //   1. デバウンス発火で送信開始（memoSaving = true）
            //   2. 往復中にさらに入力（memoUpdated = true、次のタイマーをセット）
            //   3. 送信完了で memoUpdated = false ← 手順2の編集が無かったことになる
            //   4. 次のタイマー発火 → saveMemo が !memoUpdated で早期 return
            //   5. 閉じても flushPendingMemo が memoUpdated を見て何もしない
            // 送信した内容と現在の値を比較し、差があれば未保存として残す。
            const hasNewerEdit = (this.props.state.memo || '') !== (memo || '');
            this.setState({
                memoSaved: !hasNewerEdit,
                memoUpdated: hasNewerEdit
            });

            // 「保存済み」表示のタイマー
            // Issue #406: このタイマーは componentWillUnmount でクリアする必要があるため
            // インスタンスフィールドに保持する（従来は保持しておらず、保存直後に
            // アンマウントされるとアンマウント後に setState が走っていた）
            if (this.memoSavedDisplayTimer) {
                clearTimeout(this.memoSavedDisplayTimer);
                this.memoSavedDisplayTimer = null;
            }
            // 新しい編集が残っている場合は「保存済み」を表示していないためタイマーも要らない。
            if (hasNewerEdit) {
                return;
            }
            // 3秒後に保存済み表示を消す
            this.memoSavedDisplayTimer = setTimeout(() => {
                this.memoSavedDisplayTimer = null;
                // アンマウント時にこのタイマーはクリアされるため通常は到達しないが、
                // タイマー発火とアンマウントの順序に依存しないよう明示的に確認する
                if (this._isMounted) {
                    this.setState({ memoSaved: false });
                }
            }, 3000);
        } catch (err) {
            console.error(err);
            // Issue #406: 送信中にアンマウントされた場合もメッセージは出す。
            // 理由は flushPendingMemo の catch と同じ（親のトーストであり、
            // 子のマウント状態で抑止すると保存失敗が黙殺される）。
            this.props.showErrorObjectMessage({message: 'DataUpdateError'});
        } finally {
            // 保存完了後、保存中フラグを下ろす。
            // Issue #445 ②③: インスタンスフィールドのため、アンマウント後でも
            // 確実に下ろせる（従来は setState を _isMounted で抑止しており、
            // アンマウント後は true のまま残っていた）。
            this.memoSaving = false;
            this.memoSavingValue = null;

            // Issue #445 ①: 往復中に確定した保存要求（モーダルを閉じた／録音が
            // 切り替わった時点の最新の内容）が残っていれば、ここで送り直す。
            const queued = this.queuedMemo;
            this.queuedMemo = null;
            if (queued) {
                this.postMemo(queued.ht60_id, queued.memo)
                    .catch(err => {
                        console.error(err);
                        // 通知を抑止しない理由は flushPendingMemo の catch と同じ
                        this.props.showErrorObjectMessage({message: 'DataUpdateError'});
                    });
            }
        }
    }

    componentDidUpdate(prevProps) {
        // Issue #383: 以前は componentDidUpdate がクラス内に2つ定義されており、
        // 先に書かれていた「再生位置・ハイライトのリセット」側が後の定義に
        // 上書きされて一度も実行されていなかった。両方の処理をここへ統合する。
        // modalOpened と modalClosed は show の遷移方向を表すため、
        // 同一の componentDidUpdate 呼び出しで同時に true になることはない。
        const modalOpened = !prevProps.state.show && this.props.state.show;
        const modalClosed = prevProps.state.show && !this.props.state.show;
        // 厳密等価で比較するため、id が undefined / null / 0 でも誤検知しない。
        const recordChanged = prevProps.state.id !== this.props.state.id;

        // 再生位置・文字起こしハイライトのリセット
        // モーダルを開いたときにもリセットする（同じ録音を閉じて開き直した場合に
        // 前回のシーク位置とハイライトが残らないようにする）
        if (modalOpened || recordChanged) {
            // 【#589】別の録音を開いたら通話概要は折りたたんだ状態から始め、はみ出しを測り直す
            this.setState({ activeTranscriptIndex: null, overviewExpanded: false, overviewOverflowing: false },
                () => { this.overviewRaf = window.requestAnimationFrame(this.measureOverview); });
            if (this.audioRef.current) {
                this.audioRef.current.currentTime = 0;
            }
        }

        // メモ関連ステートのリセット（モーダルが閉じられた、または別のコールが開かれた場合）
        if (modalClosed || recordChanged) {
            // Issue #406: 破棄する前に、デバウンス待ちのメモを即時保存する。
            // 保存対象は「切り替わる前」の録音。this.props は既に新しい録音を
            // 指している可能性があるため prevProps から取る。
            this.flushPendingMemo(prevProps.state.id, prevProps.state.memo);

            // タイマーをクリア
            if (this.memoSaveTimer) {
                clearTimeout(this.memoSaveTimer);
                this.memoSaveTimer = null;
            }
            if (this.memoSavedDisplayTimer) {
                clearTimeout(this.memoSavedDisplayTimer);
                this.memoSavedDisplayTimer = null;
            }

            // ステートをリセット
            // Issue #445 ①②: memoSaving はここでリセットしない。進行中の送信の
            // 完了（saveMemo の finally）で下ろし、そのタイミングでキューイング済みの
            // 内容を送り直すため、途中で false に戻すと二重送信になる。
            this.setState({
                memoSaved: false,
                memoUpdated: false // フラグをリセット
            });
        }
    }

    componentWillUnmount() {
        // Issue #406: モーダルを閉じずにアンマウントされる場合（画面遷移、
        // 親側の条件分岐による描画停止など）は componentDidUpdate を通らないため、
        // ここでもデバウンス待ちのメモを保存する。
        // _isMounted は「この子の setState を止める」ためだけに使う。
        // 保存失敗の通知（親のトースト）は抑止しない（flushPendingMemo の catch を参照）。
        this._isMounted = false;
        window.removeEventListener('resize', this.handleOverviewResize);
        if (this.overviewRaf) {
            window.cancelAnimationFrame(this.overviewRaf);
        }
        this.flushPendingMemo(this.props.state.id, this.props.state.memo);

        // タイマーのクリーンアップ
        // デバウンス待ちがあった場合は flushPendingMemo が既に clear 済み。
        // 待ちが無かった場合（memoUpdated が false、保存中など）はここで clear する。
        // 同じIDを2度渡しても仕様上無視されるため重複しても問題ない。
        if (this.memoSaveTimer) {
            clearTimeout(this.memoSaveTimer);
            this.memoSaveTimer = null;
        }
        // 「保存済み」表示のタイマーも対象にする。
        // 従来はこれが漏れており、保存直後に別種のモーダルへ切り替えて
        // アンマウントされると、アンマウント後に setState が走っていた。
        if (this.memoSavedDisplayTimer) {
            clearTimeout(this.memoSavedDisplayTimer);
            this.memoSavedDisplayTimer = null;
        }
    }

    /**
     * タグ編集モーダルからのコールバック
     * サーバーから返された最新のcategoriesでRecordPlaybackModalの表示を更新
     */
    handleCategoriesChange = (updatedCategories) => {
        this.props.propSetState({
            ht88_categories: updatedCategories
        });
        this.setState({ tagUpdated: true });
    }

    /**
     * 【#589】通話概要の要素を受け取り、折りたたみ表示で実際にはみ出しているかを測る。
     * 改行の数や文字数では、左側の幅によって折り返し後の行数が変わるため判定できない。
     */
    setOverviewRef = (el) => {
        this.overviewEl = el;
        this.measureOverview();
    }

    componentDidMount() {
        // 【#589】幅が変わると折り返し後の行数が変わるため、はみ出しを測り直す
        window.addEventListener('resize', this.handleOverviewResize);
    }

    handleOverviewResize = () => {
        if (this.overviewRaf) {
            window.cancelAnimationFrame(this.overviewRaf);
        }
        this.overviewRaf = window.requestAnimationFrame(this.measureOverview);
    }

    measureOverview = () => {
        this.overviewRaf = null;
        const el = this.overviewEl;
        if (!this._isMounted || !el || this.state.overviewExpanded) {
            return;
        }
        const overflowing = el.scrollHeight > el.clientHeight + 1;
        if (overflowing !== this.state.overviewOverflowing) {
            this.setState({ overviewOverflowing: overflowing });
        }
    }

    render() {
        let dest_tel_number;
        let btn = null;
        if (this.props.state.dest_tel_number && this.props.options
            && this.props.options.customer_infos && this.props.state.customer_name) {
            dest_tel_number = this.props.state.customer_name + "(" + this.props.state.dest_tel_number + ")";
        } else if (this.props.state.dest_tel_number) {
            dest_tel_number = this.props.state.dest_tel_number;
        } else {
            dest_tel_number = this.props.langText.Body.AnonymousNumber;
        }
        if (this.props.currentPermission.update && this.props.options
            && this.props.options.customer_infos && this.props.state.customer_name) {
            btn = <Button className = "customerAddBtn" onClick ={() => this.setState({
                show:true, modalType:"editCustomer", customer_name: this.props.state.customer_name
            })}>
                {this.props.langText.Body.CustomerEdit}
            </Button>;
        } else if (this.props.currentPermission.update && this.props.options && this.props.options.customer_infos) {
            btn = <Button className = "customerAddBtn" onClick ={() => this.setState({
                show:true, modalType:"addCustomer", customer_name: this.props.state.customer_name
            })}>
                {this.props.langText.Body.CustomerAdd}
            </Button>;
        }

        return (
            <AscModal
                state={this.props.state}
                currentPermission={this.props.currentPermission}
                onClick={this.onClickHandle}
                validationHandle={this.validationHandle}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                onCategoryEdit={
                    // Issue #349: 一覧の通話分類列と同じく契約有無で判定（サブユーザートグルの影響を受けない）
                    // Issue #549: 分類の追加・削除・統一は /Record/... が Record.update を見て
                    // 403 を返すため、更新権限が無い利用者には編集の導線自体を出さない。
                    this.canUpdateRecord()
                    && hasRecAceContract(this.props.options)
                    && this.props.state.ht88_voice_log_to_analyze
                    && this.props.state.ht87_voice_log_to_text
                        ? () => this.setState({ show: true, modalType: "tagEdit" })
                        : undefined
                }
                // No.86 コスト懸念により再実行ボタンを一時非表示（onClickHandle("voiceRetry") の機能・API は保持。ポリシー合意後に再表示する）
                onVoiceRetry={undefined}
                modalClose={() => {
                    if (this.state.tagUpdated) {
                        this.props.reactTableRefresh();
                    }
                    this.props.propSetState({ show: false });
                    this.setState({ tagUpdated: false, overviewExpanded: false });
                }}
                dialogClassName={
                  this.props.state.ht87_voice_log_to_text
                    ? "record-playback-modal"
                    : "record-playback-modal-no-text"
                }
              >
                <Row className="record-playback-container">
                  <Col lg={this.props.state.ht87_voice_log_to_text ? 6 : 12} className="record-info-column">
                    <Card variant="info">
                      <Card.Body>
                        {hasRecAceContract(this.props.options) &&
                          this.props.state.ht88_categories &&
                          this.props.state.ht88_categories.length > 0 && (
                            <InlineForm
                              key="call-categories"
                              readOnly
                              controlId={0}
                              label={this.props.langText.Body.CallCategory}
                            >
                              {this.props.state.ht88_categories.map((row, index) => (
                                <span
                                  key={row.id || index}
                                  style={{
                                    backgroundColor: row.rgb,
                                    padding: "2px 4px",
                                    borderRadius: "4px",
                                    color: row.font_rgb,
                                    marginRight: "5px",
                                  }}
                                >
                                  {row.name}
                                </span>
                              ))}
                            </InlineForm>
                          )}

                        {hasRecAceContract(this.props.options) && this.props.state.ht88_analysis_data && (
                          <InlineForm
                            key="call-analysis-data"
                            readOnly
                            controlId={0}
                            label={this.props.langText.Body.CallAnalysisData}
                          >
                            {/* 【#589】長い通話概要は折りたたみ、「すべて表示」で展開する */}
                            <div
                              ref={this.setOverviewRef}
                              className={this.state.overviewExpanded
                                ? "record-overview"
                                : "record-overview record-overview-clamped"}
                            >
                              {this.props.state.ht88_analysis_data}
                            </div>
                            {(this.state.overviewOverflowing || this.state.overviewExpanded) && (
                              <button
                                type="button"
                                className="record-overview-toggle"
                                aria-expanded={this.state.overviewExpanded}
                                onClick={() => this.setState({ overviewExpanded: !this.state.overviewExpanded })}
                              >
                                {this.state.overviewExpanded
                                  ? this.props.langText.Body.ShowLess
                                  : this.props.langText.Body.ShowAll}
                              </button>
                            )}
                          </InlineForm>
                        )}

                        <InlineForm key="external" readOnly controlId={0} label={this.props.langText.Body.ExternalNumber}>
                          {this.props.state.external_number ? this.props.state.external_number : "-"}
                        </InlineForm>

                        {!!(this.props.options && this.props.options.aspire) && (
                          <InlineForm key="extension" readOnly controlId={0} label={this.props.langText.Body.ExtensionNumber}>
                            {this.props.state.extension_number ? this.props.state.extension_number : "-"}
                          </InlineForm>
                        )}

                        <InlineForm key="dest" readOnly controlId={0} label={this.props.langText.Body.DestTelNumber}>
                          {dest_tel_number}
                          {btn}
                        </InlineForm>

                        <InlineForm key="inout" readOnly controlId={0} label={this.props.langText.Body.InOutType}>
                          {this.props.state.inout_type === "in"
                            ? this.props.langText.Body.Incoming
                            : this.props.langText.Body.Outgoing}
                        </InlineForm>

                          <InlineForm
                              key="date"
                              readOnly
                              controlId={0}
                              label={this.props.langText.Body.CallDate}>
                              {moment(this.props.state.answer_datetime).utc().add(9, "h").format("YYYY-MM-DD HH:mm:ss")}
                          </InlineForm>
                          {/* メモ入力欄（録音音声の上に表示） */}
                          <InlineForm
                              key="memo"
                              controlId="memo"
                              label={this.props.langText.Body.Memo}>
                              <div style={{ position: 'relative' }}>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    maxLength={256}
                                    value={this.props.state.memo || ''}
                                    onChange={this.onMemoChange}
                                    onBlur={this.onMemoBlur}
                                    // 【#549】更新権限が無い利用者には入力させない。
                                    // 入力を促す文言の代わりに、閲覧専用である旨を出す
                                    // （空欄だけだと「メモが無い」のか「編集できない」のかが伝わらない）。
                                    readOnly={!this.canUpdateRecord()}
                                    placeholder={this.canUpdateRecord()
                                        ? this.props.langText.Message.Placeholder_InputMemo
                                        : this.props.langText.Message.Placeholder_MemoReadOnly}
                                />
                                  {this.state.memoSaved && (
                                      <div style={{
                                          position: 'absolute',
                                          bottom: '8px',
                                          right: '12px',
                                          fontSize: '12px',
                                          color: '#28a745',
                                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                          padding: '2px 6px',
                                          borderRadius: '3px'
                                      }}>
                                          保存済み
                                      </div>
                                  )}
                              </div>
                          </InlineForm>
                        {/* 【#589】左側をスクロールしても再生できるよう、録音音声は左側の下端に固定する */}
                        <div className="record-audio-sticky">
                        <InlineForm key="audio" readOnly controlId={0} label={this.props.langText.Body.Voice}>
                          <audio
                            key="recorded-voice-audio"
                            className="recorded-voice-audio"
                            ref={this.audioRef}
                            controls={true}
                            controlsList="nodownload"
                            autoPlay={false}
                          >
                            <source src={this.props.state.url} type="audio/mp3" />
                          </audio>
                        </InlineForm>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  {this.props.state.ht87_voice_log_to_text && (
                    <Col lg={6} className="record-text-column">
                      <Card variant="info" className="voice-text-card">
                        <Card.Body className="voice-text-body">
                          {InlineForm.static({
                            controlId: 0,
                            labelCol: 12,
                            formCol: 0,
                            label: this.props.langText.Body.audio2text,
                          })}
                          <div className={"voice-text-panel-side"}>
                            {this.viewVoiceMessage(this.props.state.ht87_voice_log_to_text)}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  )}
                </Row>

                {this.getModalBranch()}
            </AscModal>
        );
    }
}
